<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { MediaUploaderModal, Alert } from "@components";
import Prompt from "@components/Prompt.vue";

const router = useRouter();

onMounted(() => {
  if (prebook_admin.setup.completed) {
    router.push({ name: "dashboard" });
  }
});
</script>

<template>
  <div>
    <Alert class="fixed top-3 right-5" />
    <Prompt />

    <router-view></router-view>

    <div class="overflow-y-scroll">
      <MediaUploaderModal />
    </div>
  </div>
</template>

<style>
.circle-1 {
  position: absolute;
  width: 466px;
  height: 466px;
  border-radius: 100%;
  background: #ffa2be80;
  filter: blur(177px);
  transform: rotate(15deg);
  left: -195.39px;
  top: 108px;
}

.circle-2 {
  position: absolute;
  width: 441px;
  height: 441px;
  left: 123.46px;
  top: 462.59px;
  border-radius: 100%;
  background: rgba(80, 9, 247, 0.3);
  filter: blur(177px);
  transform: rotate(15deg);
}

.circle-3 {
  position: absolute;
  width: 441px;
  height: 441px;
  left: -57.86px;
  top: 889px;
  border-radius: 100%;
  background: #fe8d2366;
  filter: blur(177px);
  transform: rotate(15deg);
}
</style>
